import { useQuery } from "hooks/useQuery";
import { getStrategyCollectionDetails } from "features/Strategy/service";

export const useStrategyCollectionDetails = (slug) => {
  const { data, isLoading } = useQuery({
    key: "strategyCollectionDetails",
    queryKey: ["strategyCollectionDetails", slug],
    queryFn: async () => {
      if (!slug) return null;
      const response = await getStrategyCollectionDetails(slug);
      return response;
    },
    enabled: !!slug,
  });

  return {
    data,
    isLoading,
  };
};
